import { schemaDocumentSnapshotQueryOptions } from '@valian/react-kitchen-sink'

import { collections } from '@/schema'

export const promotionsConfigurationQuery = () =>
  schemaDocumentSnapshotQueryOptions({
    queryKey: ['configurations', 'Promotions'],
    factory: collections.configurations,
    id: 'Promotions',
  })
